module.exports = __webpack_public_path__ + "img/product2_FF6B00_age.bdded512.png";